import { render, staticRenderFns } from "./BossCodes.vue?vue&type=template&id=8c4ab99e&scoped=true&"
import script from "./BossCodes.vue?vue&type=script&lang=js&"
export * from "./BossCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4ab99e",
  null
  
)

export default component.exports